import { useRef } from "react";

export const useConst = <T>(initialiser: () => T): T => {
  const ref = useRef<{ value: T } | undefined>(undefined);
  ref.current ??= { value: initialiser() };
  return ref.current.value;
};
